newAddVariantToCart = (targetIndex) => {
let formData = {
            'items': window.tlDiscounts.addToCartData[targetIndex].map((variant) => {
                return {
                    'id': parseInt(variant.id),
                    'quantity': parseInt(variant.quantity)
                }
            })
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(() => {
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error:', error);
            });

};

const overwriteRenderAdvancedFreeGift = () => {
  if (window.tlDiscounts) {
    clearInterval(intervalId);
    window.tlDiscounts.addVariantToCart= newAddVariantToCart;
  }
}

const intervalId = setInterval(overwriteRenderAdvancedFreeGift, 50);
  setTimeout(() => {
  clearInterval(intervalId);
}, 3000);